<template>
<div class="anim__wrapper">
  <Paragraph 
    v-html="text"
    :text="text"
    :data-anim="isMobile() ? false : ''"
  />
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Paragraph from '@/components/typo/Paragraph';

import { isMobile } from '@/scripts/utils';


export default {
  name: 'Weather',

  components: {
    Paragraph,
  },

  data() {
    return {
      text: '',
      isMobile,
    };
  },


  watch: {
    weatherData(newVal) {
      if (newVal) this.changeTime(parseInt(newVal.id, 10));
    },

    lang(newVal, oldVal) {
      if (newVal && oldVal) {
        this.changeTime(parseInt(this.weatherData.id, 10));
      }
    },
  },
  created() {
    this.$store.dispatch('FETCH_WEATHER');
  },

  computed: {
    ...mapGetters({
      weatherData: 'getWeatherData',
      lang: 'getLang',
    }),
  },

  methods: {
    changeTime(id) {
      switch (true) { // eslint-disable-line
        case (id < 299): // Thunderstorm
          if (this.lang === 'it') {
            this.text = 'Festeggiamo sfidando la tempesta.';
          } else {
            this.text = 'In the storm, we party.';
          }
          break;

        case (id < 399): // Drizzle
          if (this.lang === 'it') {
            this.text = 'Non saranno due gocce a fermare la nostra festa.';
          } else {
            this.text = 'Drizzle won\'t stop us';
          }
          break;

        case (id < 599): // Rain
          if (this.lang === 'it') {
            this.text = 'Qui danziamo nella pioggia!';
          } else {
            this.text = 'We\'re dancing in the rain!';
          }
          break;

        case (id < 699): // Snow
          if (this.lang === 'it') {
            this.text = 'Guerra a palle di neve dietro l\'angolo!';
          } else {
            this.text = 'Snowball war incoming!';
          }
          break;

        case (id < 799): // Atmosphere
          if (this.lang === 'it') {
            this.text = 'Nebbia o sabbia, l\'importante è che si veda il calice!';
          } else {
            this.text = 'Sand or fog, what matters is to see your glass!';
          }
          break;

        case (id >= 800): // Clear
          if (this.lang === 'it') {
            this.text = 'Il cielo terso chiama Festa!';
          } else {
            this.text = 'A crystal clear sky calls for a party!';
          }
          break;

        // case (id > 800): // Clear
        //   this.text = 'Remember there\'s only a cloud between you and the sun.';
        //   break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../application';

.anim__wrapper {
  flex: 0 0 50%;

  @include mq(sm) {
    max-width: 200px;
    flex: 1 0 0;

    p {
      line-height: 1.4;
    }
  }

  @include mq(md) {
    max-width: none;

    p {
      line-height: 1.875;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/header/Weather.vue